// marketing-site/src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const env = import.meta.env || {};
const host = (typeof window !== 'undefined' && window.location.host) || '';

/**
 * Preview channels do Firebase Hosting têm host no formato
 * `<site>--<channel>-<hash>.web.app` e apontam para o projeto de staging.
 * Qualquer outro host (domínio custom ou <site>.web.app) é produção.
 */
const isChannelHost = /\.web\.app$/i.test(host) && host.includes('--');
const target = isChannelHost ? 'staging' : 'production';

const suffix = isChannelHost ? '_STAGING' : '';
const read = (name) => env[`VITE_FIREBASE_${name}${suffix}`] || '';

const config = {
  apiKey: read('API_KEY'),
  authDomain: read('AUTH_DOMAIN'),
  projectId: read('PROJECT_ID'),
  storageBucket: read('STORAGE_BUCKET'),
  messagingSenderId: read('MSG_SENDER'),
  appId: read('APP_ID'),
};

// Falha explícita em vez de cair silenciosamente num projeto padrão: uma
// waitlist gravada no projeto errado não gera convite e o erro fica invisível.
const missing = Object.entries(config)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missing.length > 0) {
  const msg = `[MarketingFirebase] Config incompleta para "${target}". Faltando: ${missing.join(', ')}`;
  console.error(msg, 'host=', host);
  throw new Error(msg);
}

if (typeof window !== 'undefined') {
  console.info('[MarketingFirebase] host=', host, 'target=', target, 'projectId=', config.projectId);
}

const app = initializeApp(config);

export const db = getFirestore(app);
export const getEnvironmentTag = () => target;
export const getCurrentHost = () => host;
